import React from 'react';
import { useSelector } from 'react-redux';
import { Icon } from '../../../CommonComponents/OPL/Icon/Icon';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { Tooltip } from '../../../CommonComponents/OPL/Tooltip/Tooltip';
import { selectIsUserClient } from '../../../CommonSelectors/CommonAreaSelector';
import { WorkflowTileButton } from './WorkflowTile.styles';
import { Props as VisualPickerButtonContainerProps } from '../../../CommonComponents/OPL/VisualPickerButton/VisualPickerButtonContainer';
import { CustomIcon } from './components/CustomIcon/CustomIcon';

interface Props extends VisualPickerButtonContainerProps {
  name: string;
  description?: string;
  checked: boolean;
  icon: string;
  isCustomIcon?: boolean;
  onClick(): void;
}

export const WorkflowTile = ({
  name,
  icon,
  checked,
  description,
  isCustomIcon,
  ...rest
}: Props) => {
  const isUserClient = useSelector(selectIsUserClient);

  return (
    <WorkflowTileButton aria-pressed={checked} {...rest}>
      {isCustomIcon ? (
        <CustomIcon icon={icon} checked={checked} />
      ) : (
        <Icon className={icon} fontSize="h3" color={checked ? 'primary.600' : 'neutral.500'} />
      )}

      <Text
        as="span"
        fontSize="h6"
        fontWeight={600}
        color={checked ? 'primary.600' : 'neutral.600'}
        textAlign="center"
      >
        {name}
      </Text>

      {description && (
        <Text
          as="span"
          fontSize="small"
          color={checked ? 'primary.500' : 'neutral.500'}
          textAlign="center"
        >
          {description}
        </Text>
      )}

      {checked && (
        <Tooltip
          content={
            isUserClient ? 'You completed this workflow' : 'Your client completed this workflow'
          }
          placement="bottom"
        >
          <Icon className="fas fa-check-circle" fontSize="h6" color="primary.600" />
        </Tooltip>
      )}
    </WorkflowTileButton>
  );
};
